import React from 'react';
import '../App.css';
import {
    Row,
    Col,
    Button
} from 'bootstrap-4-react';

import TexturesRow from "./TexturesRow";
import WorkSpeedRow from "./WorkSpeedRow";
import EquipmentRow from "./EquipmentRow";
import ProductsRow from "./ProductsRow";
import SalesRow from "./SalesRow";

function EventProgram() {

    return (
        <Row id={'eventProgram'}>
            <Col col="md-12">
                <h3 className="rowTitle" style={{marginLeft: '-0.2em'}}>На вебинаре вы узнаете</h3>
                <div className={'eventProgram-content'}>
                    <TexturesRow />
                    <WorkSpeedRow />
                    <EquipmentRow />
                    {/*<SalesRow />*/}

                </div>

            </Col>
        </Row>



    );
}

export default EventProgram;
